export default "__VITE_ASSET__DxjbsHMA__"